import { SyntheticEvent } from 'react'

import { FormControl } from '@mui/material'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@collaborate-health/uikit'

export interface ExportCustomVideoOptionsDialogProps {
  isCustomVideoOptionsDialogOpen: boolean
  closeDialog: () => void
  next: () => void
  isShowProgress: boolean
  setCustomVideoOption: (e: SyntheticEvent<Element, Event>, value: number) => void
  selectedOption: number
  exportOptions: Array<{ Id: number; Value: string }>
}

const ExportCustomVideoOptionsDialog: React.FC<ExportCustomVideoOptionsDialogProps> = ({
  isCustomVideoOptionsDialogOpen,
  closeDialog,
  next,
  isShowProgress,
  setCustomVideoOption,
  selectedOption,
  exportOptions,
}) => {
  return (
    <Dialog open={isCustomVideoOptionsDialogOpen} maxWidth='xs' fullWidth onClose={closeDialog}>
      <DialogTitle>Export session media in the order of</DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup value={selectedOption}>
            {exportOptions.map((option) => (
              <FormControlLabel
                key={option.Id}
                value={option.Id}
                control={<Radio />}
                label={option.Value}
                onChange={(e) => setCustomVideoOption(e, option.Id)}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={closeDialog}>
          Close
        </Button>
        <Button color='primary' loading={isShowProgress} variant='contained' onClick={next}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportCustomVideoOptionsDialog

